import { useTranslation as useI18nTranslation } from 'react-i18next';

export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const getCurrentLanguage = () => {
    return i18n.language;
  };

  const getAvailableLanguages = () => {
    return [
      { code: 'zh-TW', name: '繁體中文', nativeName: '繁體中文' },
      { code: 'zh-CN', name: '简体中文', nativeName: '简体中文' },
      { code: 'en', name: 'English', nativeName: 'English' }
    ];
  };

  return {
    t,
    changeLanguage,
    getCurrentLanguage,
    getAvailableLanguages,
    i18n
  };
};
